import { render } from "./MemberSector.vue?vue&type=template&id=07fd68e3&scoped=true"
import script from "./MemberSector.vue?vue&type=script&lang=js"
export * from "./MemberSector.vue?vue&type=script&lang=js"

import "./MemberSector.vue?vue&type=style&index=0&id=07fd68e3&scoped=true&lang=css"

import exportComponent from "/var/www/admin_web_aaac/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-07fd68e3"]])

export default __exports__